import React from "react";
import { useLang } from "../lib/LanguageContext";
import PageHeader from "../components/PageHeader";
import {
  Laptop, BookOpen, Monitor, FlaskConical, Dumbbell,
  ShieldCheck, HeartPulse, Droplets, Sparkles,
} from "lucide-react";

const ICONS = [Laptop, BookOpen, Monitor, FlaskConical, Dumbbell, ShieldCheck, HeartPulse, Droplets, Sparkles];

const GALLERY = [
  "/site/campus-1.png",
  "/site/campus-2.png",
  "/site/campus-3.png",
  "/site/campus-4.png",
];

const Facilities = () => {
  const { t, lang } = useLang();
  const p = t.facilitiesPg;

  return (
    <div data-testid="facilities-page">
      <PageHeader eyebrow={t.nav.facilities} title={p.title} subtitle={p.sub} testId="facilities-header" />

      <section className="section-pad">
        <div className="container-school grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {p.list.map((f, i) => {
            const Icon = ICONS[i] || Sparkles;
            return (
              <div key={i} className="card-soft p-7" data-testid={`facility-page-card-${i}`}>
                <div className="w-14 h-14 rounded-2xl bg-school-primary/10 flex items-center justify-center mb-5">
                  <Icon className="w-7 h-7 text-school-primary" />
                </div>
                <h3 className="font-heading font-bold text-xl text-school-text">{f.title}</h3>
                <p className="mt-3 text-base text-school-muted leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </section>

      {/* Gallery */}
      <section className="section-pad bg-school-muted/50">
        <div className="container-school">
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-school-primary">
            {lang === "mr" ? "आमच्या परिसराची झलक" : "A glimpse of our campus"}
          </h2>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {GALLERY.map((src, i) => (
              <div key={i} className="rounded-2xl overflow-hidden shadow-md border border-school bg-white" data-testid={`gallery-item-${i}`}>
                <div className="aspect-[4/3] w-full">
                  <img src={src} alt={`Campus ${i + 1}`} loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Facilities;
